
export type CountryCode = 'US' | 'CA' | 'GB' | 'AU' | 'NG';

export interface RegionalServices {
  bankConnections: string[];
  creditChecks: string[];
  propertyData: string[];
  paymentProcessing: string[];
}

export interface Country {
  code: CountryCode;
  name: string;
  flag: string;
}

export const SUPPORTED_COUNTRIES: Country[] = [
  { code: 'US', name: 'United States', flag: '🇺🇸' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦' },
  { code: 'GB', name: 'United Kingdom', flag: '🇬🇧' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺' },
  { code: 'NG', name: 'Nigeria', flag: '🇳🇬' },
];

export const REGIONAL_SERVICES: Record<CountryCode, RegionalServices> = {
  US: {
    bankConnections: ['Plaid'],
    creditChecks: ['Experian', 'Equifax', 'TransUnion'],
    propertyData: ['Zillow', 'Rentals.com'],
    paymentProcessing: ['Stripe', 'ACH']
  },
  CA: {
    bankConnections: ['Plaid'],
    creditChecks: ['Equifax Canada', 'TransUnion Canada'],
    propertyData: ['Rentals.ca', 'Kijiji'],
    paymentProcessing: ['Stripe', 'Interac']
  },
  GB: {
    bankConnections: ['GoCardless'],
    creditChecks: ['Experian UK', 'Equifax UK', 'TransUnion UK'],
    propertyData: ['Rightmove', 'Zoopla'],
    paymentProcessing: ['Stripe', 'GoCardless']
  },
  AU: {
    bankConnections: [],
    creditChecks: ['Experian AU', 'Equifax AU'],
    propertyData: ['Domain', 'REA'],
    paymentProcessing: ['Stripe']
  },
  NG: {
    bankConnections: [],
    creditChecks: [],
    propertyData: [],
    paymentProcessing: ['Stripe']
  }
};

export const getServicesForCountry = (countryCode: CountryCode): RegionalServices => {
  return REGIONAL_SERVICES[countryCode] || REGIONAL_SERVICES.GB;
};
